import { makeStyles } from '@material-ui/core';
import { CartPiece } from 'components/WidgetInflationCart/WidgetInflationCart';
import React from 'react';

interface MedicalCardProps {
    card: CartPiece;
}

const useStyles = makeStyles((theme) => ({
    medicalCard: {
        backgroundColor: '#364F6B',
        width: '298px',
        height: '363px',
        flexShrink: 0,
        borderRadius: '10px',
        padding: '20px',
        [theme.breakpoints.down('sm')]: {
            height: '300px',
        },
    },
    svg: {
        width: '79px',
        height: '60px',
        flexShrink: 0,
    },
    h3: {
        color: theme.colors.white,
        textAlign: 'center',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 'normal',
        width: '220px',
        height: '35px',
        flexShrink: 0,
        margin: '0px auto 18px',
    },
    li: {
        color: theme.colors.white,
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        // lineHeight: 'normal',
        lineHeight: '25px' /* 178.571% */,
        flexShrink: 0,
    },
    svgIcon: {
        textAlign: 'center',
    },
}));

const Medical = ({ card }: MedicalCardProps) => {
    const classes = useStyles();
    return (
        <div className={classes.medicalCard}>
            <div className={classes.svgIcon}>
                <svg
                    className={classes.svg}
                    xmlns="http://www.w3.org/2000/svg"
                    width="79"
                    height="60"
                    viewBox="0 0 79 60"
                    fill="white"
                    data-card={card.card}
                >
                    <path
                        d="M78.9912 11.0165C78.9912 8.48768 78.5699 6.44014 77.7361 4.9526C76.876 3.41257 75.5858 2.5288 73.9884 2.3538C73.7339 1.01502 72.6544 0 71.3642 0C70.5743 0 70.0038 0.402508 69.7668 1.12002C69.5913 1.63628 69.5913 2.27505 69.5913 2.97506C69.5913 3.67508 69.5913 4.29634 69.7668 4.8126C70.0126 5.53886 70.5743 5.93262 71.3642 5.93262C72.628 5.93262 73.6813 4.96135 73.9621 3.66633C77.1744 4.12134 77.6747 8.40018 77.6747 11.0077C77.6747 15.6016 76.1826 21.2279 73.7778 25.6993C72.2243 28.5868 68.9418 33.4344 64.4217 33.4344C59.9017 33.4344 56.6192 28.5868 55.0657 25.6993C52.6608 21.2279 51.1688 15.6016 51.1688 11.0077C51.1688 8.73268 51.5462 6.86014 52.2571 5.58262C52.889 4.45384 53.7491 3.82383 54.8813 3.66633C55.171 4.9701 56.2242 5.94137 57.4793 5.94137C58.2692 5.94137 58.8397 5.53886 59.0767 4.82135C59.2522 4.30509 59.2522 3.66633 59.2522 2.96631C59.2522 2.2663 59.2522 1.64503 59.0767 1.12877C58.8309 0.402508 58.2692 0.00875038 57.4793 0.00875038C56.1891 0.00875038 55.1183 1.01502 54.855 2.36255C53.2576 2.53755 51.9674 3.42132 51.1073 4.96135C50.2735 6.44888 49.8522 8.49643 49.8522 11.0252C49.8522 20.3354 55.6537 34.0207 63.7723 34.7295V48.9485C63.7723 54.3211 59.4014 58.6962 54.0212 58.6962C48.641 58.6962 44.2702 54.3211 44.2702 48.9485V41.4234H51.3794C51.7393 41.4234 52.0377 41.1259 52.0377 40.7671V25.0343C52.0377 24.6755 51.7393 24.378 51.3794 24.378H34.5894V7.64766C34.5894 7.2889 34.291 6.9914 33.9311 6.9914H18.1065C17.7467 6.9914 17.4483 7.2889 17.4483 7.64766V24.3693H0.65826C0.298411 24.3693 0 24.6668 0 25.0255V40.7584C0 41.1171 0.298411 41.4146 0.65826 41.4146H17.4483V58.1362C17.4483 58.495 17.7467 58.7925 18.1065 58.7925H33.9136C34.2734 58.7925 34.5718 58.495 34.5718 58.1362V41.4146H42.9449V48.9398C42.9449 55.0386 47.9126 60 54.0124 60C60.1123 60 65.08 55.0386 65.08 48.9398V34.7207C73.1898 34.012 79 20.3267 79 11.0165H78.9912ZM71.3642 4.62885C71.1009 4.62885 71.0658 4.55884 71.0131 4.40134C70.9078 4.08633 70.9078 3.55257 70.9078 2.95756C70.9078 2.36255 70.9078 1.85504 71.0131 1.54003C71.0658 1.38253 71.1009 1.31253 71.3642 1.31253C72.119 1.31253 72.7334 2.05629 72.7334 2.96631C72.7334 3.87633 72.119 4.6201 71.3642 4.6201V4.62885ZM57.4705 1.31253C57.7338 1.31253 57.7689 1.38253 57.8216 1.54003C57.9269 1.85504 57.9269 2.3888 57.9269 2.98381C57.9269 3.57883 57.9269 4.08633 57.8216 4.40134C57.7689 4.55884 57.7338 4.62885 57.4705 4.62885C56.7157 4.62885 56.1013 3.88508 56.1013 2.97506C56.1013 2.06504 56.7157 1.32128 57.4705 1.32128V1.31253ZM33.9136 40.1021C33.5537 40.1021 33.2553 40.3996 33.2553 40.7584V57.4799H18.7648V40.7584C18.7648 40.3996 18.4664 40.1021 18.1065 40.1021H1.31652V25.6818H18.1065C18.4664 25.6818 18.7648 25.3843 18.7648 25.0255V8.30392H33.2553V25.0255C33.2553 25.3843 33.5537 25.6818 33.9136 25.6818H50.7036V40.1021H44.2526V37.267C46.6487 36.952 48.5006 34.9307 48.5006 32.4807C48.5006 29.8206 46.2976 27.6506 43.5944 27.6506C40.8911 27.6506 38.6881 29.8206 38.6881 32.4807C38.6881 34.922 40.5401 36.9433 42.9361 37.267V40.1021H33.9048H33.9136ZM43.6032 36.007C41.6284 36.007 40.0134 34.432 40.0134 32.4894C40.0134 30.5469 41.6196 28.9719 43.6032 28.9719C45.5867 28.9719 47.1929 30.5469 47.1929 32.4894C47.1929 34.432 45.5867 36.007 43.6032 36.007Z"
                        fill="white"
                    />
                </svg>
            </div>
            <hr />
            <h3 className={classes.h3}>{card.header}</h3>
            <ul>
                {card.list.map((item) => (
                    <li
                        className={classes.li}
                        key={`${card.card}-${Math.random()}`}
                    >
                        {item.desc}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Medical;
